const fileExtensionRx = /\.(\w{1,4})$/i
export const isDataFile = fileName => (/(\.sav|\.sav\.zip)$/i).test(fileName)
export const getBadgeFileType = fileName => {
  if (isDataFile(fileName)) {
    return 'DATA'
  }
  return fileExtensionRx.exec(fileName)?.[1]?.toUpperCase() ?? '???'
}
